export enum DefaultRoute {
  ROOT = "Root",
  CUSTOMER_HOSTED = "WorkspacesList",
  SAAS_BROWSER = "LandingPage",
  SAAS_APP_LAUNCHER = "AppLauncherCollection",
  LOGIN = "Login"
}
